const UserIcon = () => {
    return (
        <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M15.125 8.25C15.125 10.5282 13.2782 12.375 11 12.375C8.72183 12.375 6.875 10.5282 6.875 8.25C6.875 5.97183 8.72183 4.125 11 4.125C13.2782 4.125 15.125 5.97183 15.125 8.25Z" fill="currentColor" />
            <path fillRule="evenodd" clipRule="evenodd" d="M0 11C0 4.92487 4.92487 0 11 0C17.0751 0 22 4.92487 22 11C22 17.0751 17.0751 22 11 22C4.92487 22 0 17.0751 0 11ZM11 1.375C5.68426 1.375 1.375 5.68426 1.375 11C1.375 13.2735 2.16323 15.3628 3.48131 17.0097C4.45903 15.4347 6.60638 13.75 11 13.75C15.3936 13.75 17.541 15.4347 18.5187 17.0097C19.8368 15.3628 20.625 13.2735 20.625 11C20.625 5.68426 16.3157 1.375 11 1.375Z" fill="currentColor" />
        </svg>
    )
}

export default UserIcon;